import Router from 'routes/routes';
import React, { Suspense, useEffect, useState } from 'react';
import './App.css';
import { HeaderComponent } from 'common/HeaderComponent';
import Cookies from 'js-cookie';
import { ModalComponent } from "common/ModalComponent";
import axios from 'axios';
import * as Constants from './requests/URLConstants'
import callPostApi from "./requests/PostRequests";
import SAP from "./assets/image/SAP.svg";
import Automation from "./assets/image/Automation.svg";
import i18n from "./i18n"
import * as workspaces from './config/WorkspaceConstants';
import { ReactComponent as QuestChat } from "assets/image/QuestChat.svg";
import { Button } from 'carbon-components-react';
import QuestModal from 'components/Quest/QuestModal'
import * as configConst from "./config/Constants"

const AutomationOperations = i18n.t('pageHeader.app.AutomationOperations');
const SAPOperations = i18n.t('pageHeader.app.SAPOperations');
const AutomationLabel = i18n.t('pageHeader.app.Automation');
const SAPLabel = i18n.t('pageHeader.app.SAP');
const SelectWorkspace = i18n.t('pageHeader.app.SelectWorkspace');
const SessionExpired = i18n.t('pageHeader.app.SessionExpired');
const UserPreferenceslabel1 = i18n.t('pageHeader.app.UserPreferenceslabel1');
const UserPreferenceslabel2 = i18n.t('pageHeader.app.UserPreferenceslabel2');
const loadingLabel = i18n.t('pageHeader.app.loadingLabel');
const LoginAgain = i18n.t('pageHeader.app.LoginAgain');
const OEMOperations = i18n.t('pageHeader.app.OEMOperations');
const SalesForceOperations = i18n.t('pageHeader.app.SalesForceOperations');
const CustomOperations = i18n.t('pageHeader.app.CustomOperations');
var config = require('./config/appConfig.json');

const jwt = require('jsonwebtoken')

const CHECK_INTERVAL = 10000 // in ms
// window.screen.orientation.lock('landscape');
let WORKSPACES = [
  {
    id: workspaces.automation_ops,
    name: AutomationOperations,
    isSelected: false,
  }
  ,
  {
    id: workspaces.sap_ops,
    name: SAPOperations,
    isSelected: false,
  },
  // {
  //   id: workspaces.oem_ops,
  //   name: OEMOperations,
  //   isSelected: false,
  // },
];

(configConst.URL.includes(configConst.staging) || configConst.URL.includes(configConst.development) || configConst.URL.includes(configConst.local)) &&
    WORKSPACES.push({
        id: workspaces.salesforce_ops,
        name: SalesForceOperations,
        isSelected: false,
    })

configConst.URL.includes(configConst.unilever) === false &&
    WORKSPACES.push({
        id: workspaces.custom_ops,
        name: CustomOperations,
        isSelected: false
    })

const App = (props) => {

    const [autoRefreshTokenAPICalled, setAutoRefreshTokenAPICalled] = React.useState(false);;
    const [showModal, setShowModal] = React.useState(false);
    const [showSessionTimeOut, setSessionTimeOut] = React.useState(false);
    const [showLoginTimeOut, setLoginTimeOut] = React.useState(false);
    const [workspace, setWorkspace] = React.useState();
    const [isWorkspaceLoaded, setWorkspaceLoaded] = React.useState(false);
    const [isWorkspaceNotAvailable, setWorkspaceNotAvailable] = React.useState(false);
    const [isFirstTimeLogin, setFirstTimeLogin] = React.useState(true);
    const [sessionToken, setSessionToken] = useState('');
    const [showQuestModal, setShowQuestModal] = useState(false);
    const [questLoading, setQuestLoading] = useState(false);

    const AskMe = i18n.t('manageAutomation.AskMe');


    useEffect(() => {
        // initInterval();
        //console.log("Auto refres" + autoRefreshTokenAPICalled);
        getUserPreferences();

    }, [showSessionTimeOut]);


    useEffect(() => {
        let id = setInterval(() => {
            check();
        }, CHECK_INTERVAL);
        return () => clearInterval(id);
    });

    useEffect(() => {
        var access_token = localStorage.getItem('kc_access_token');
        // if(access_token) {
        //   getQuest();
        // } else {
        //   window.addEventListener('storage', getQuest);
        //   return () => window.removeEventListener('storage', getQuest);
        // }

    }, []);

    useEffect(() => {
        // getUserPreferences();
    }, [isWorkspaceLoaded]);

    const modalFooterSession = () => ({
        primaryButtonText: "Login Again",
        secondaryButtonText: "Refresh Token",
        primaryButtonKind: "primary",
        secondaryButtonKind: "secondary"
    });

    const modalFooterLoginSession = () => ({
        primaryButtonText: LoginAgain,
        // secondaryButtonText: null,
        primaryButtonKind: "primary",
        secondaryButtonKind: null
    });

    const handleClickLogin = () => {
        let url = config.serverUrl + '/api/logout';
        // setSessionTimeOut(false);

        axios.get(url, {
            withCredentials: true,
            credentials: "include",
            headers: {
                'Content-Type': 'application/json'
            },
        }).then(response => {
            //console.log(response);
            setSessionTimeOut(false);
            return response;
        }).then(resp => {
            setSessionTimeOut(false);

            let redirect_value = resp.data.redirect
            if (resp && resp.data && resp.data.redirect) {
                window.location.href = redirect_value;
            } else {
                window.location.href = "/";
            }

        }).catch((error) => {
            console.error('Error:', error);
        });
    }

    const refreshToken = () => {
        //console.log('refreshToken API:');

        //console.log('refreshToken url:', config.serverUrl);

        fetch(config.serverUrl + '/api/refreshToken', {
            method: 'GET',
            //   cache: 'no-cache', // *default, no-cache, reload, force-cache, only-if-cached
            withCredentials: true,
            credentials: "include",
            headers: {
                'Content-Type': 'application/json'
            },
            //   redirect: 'follow', // manual, *follow, error
            //   referrerPolicy: 'no-referrer', // no-referrer, *no-referrer-when-downgrade, origin, origin-when-cross-origin, same-origin, strict-origin, strict-origin-when-cross-origin, unsafe-url
            // body: {} // body data type must match "Content-Type" header
        })
        .then(response => response.json())
        .then(result => {
            console.log('result:' + result)
            if (result.status !== 'success') {
                // logout api
                handleClickLogin();
            } else {
                console.log("user deetails refresh data",result.es_resp.access_token,result.es_resp.refresh_token);
                localStorage.setItem("user", JSON.stringify(result.es_resp));
                onQuestLoad(result.es_resp.access_token,result.es_resp.refresh_token);
                // // autoRefreshTokenAPICalled = false;
                // setAutoRefreshTokenAPICalled(false);
                // setSessionTimeOut(false);
            }
        }).catch((error) => {
            console.error('Error:', error);
            setLoginTimeOut(true);
        });

    }

    const check = () => {
        var session_token = Cookies.get('session_token');
        setSessionToken(session_token);
        //console.log('session_token:::'+session_token);
        //Check except login and login callback i.e. for protected routes.
        if (session_token) {

            if (!isWorkspaceLoaded) {
                getUserPreferences();
            }
            const payload = jwt.decode(session_token);

            // var expDate = new Date(0); // The 0 there is the key, which sets the date to the epoch
            var expDate = new Date(payload.exp * 1000); // The 0 there is the key, which sets the date to the epoch

            // expDate.setUTCSeconds(payload.exp);
            //console.log('exp date:::'+expDate);

            var currentTime = new Date().getTime();
            var expiryTime = expDate.getTime();
            var buffer = (2 * 60 * 1000);

            //console.log('currentTime:::'+currentTime);
            //console.log('expiryTime:::'+expiryTime);
            //console.log('buffer:::'+buffer);

            if (currentTime >= (expiryTime - buffer) && (currentTime - expiryTime <= buffer)) {
                // setAutoRefreshTokenAPICalled(true);
                // setSessionTimeOut(true);
                //console.log("Check Function called");
                refreshToken();
            }
        }
        // else {
        //   setLoginTimeOut(true);
        // }
    }



    const getEmailHandler = () => {
        setShowModal(!showModal);
        window.location.href = "/taskDetails";

    }
    const updateWorkspace = (_workspace) => {
        if (_workspace !== workspace) {
            let user = JSON.parse(localStorage.getItem('user'));
            updateUserPreferences(user.username, _workspace);
        }
    }

    const updateUserPreferences = async (user, workspace) => {
        let body = { "user": user };
        let bodyJSON = {};
        bodyJSON.user = body.user;
        if (workspace) {
            bodyJSON.workspace = workspace;
        }

        callPostApi(Constants.UPDATEUSERPREFRENCESURL, {
            'Content-Type': 'application/json'
        }, bodyJSON)
            .then(resp => {
                getUserPreferences(body.user);

            }).catch((error) => {
                console.error('Error:', error);
            });
    };


    const getUserPreferences = async () => {

        //Check except login and login callback i.e. for protected routes.
        let user = JSON.parse(localStorage.getItem('user'));
        if (user) {
            let body = { 'user': user.username };


            callPostApi(Constants.GETUSERPREFRENCESURL, {
                'Content-Type': 'application/json'
            }, body).then(respJson => {
                if (respJson && respJson && respJson._source) {
                    if (respJson._source.workspace) {
                        setWorkspaceNotAvailable(false);
                        setFirstTimeLogin(false);
                        setWorkspace(respJson._source.workspace);
                        WORKSPACES.map(workspace => (
                            workspace.isSelected = (workspace.id === respJson._source.workspace ? true : false)
                        ));
                        setWorkspaceLoaded(true);
                    }

                } else {
                    if (respJson === 500) {
                        setWorkspaceNotAvailable(true);
                    } else {
                        setFirstTimeLogin(false);
                    }
                }

            }).catch((error) => {
            });
        }

    }

    const getToken = (access_token,refresh_token) => {
        const user = JSON.parse(localStorage.getItem("user"));
        let authInfo = {
            type: "ELKTokenFromDO",
            token: { accessToken: access_token, refreshToken: refresh_token }
        };
        if(access_token && refresh_token) {
            return authInfo;
        } else if(Object.keys(user).length && user.access_token){
            authInfo = {
                type: "ELKTokenFromDO",
                token: { accessToken: user.access_token, refreshToken: user.refresh_token }
            }
            return authInfo;
        } else {
            getToken(access_token,refresh_token);
        }
    };

    const toggleQuestModal = () => {
        setQuestLoading(true);
        setShowQuestModal(!showQuestModal);
    }

    const onQuestLoad = (access_token,refresh_token) => {
        var iframe = document.getElementsByTagName('iframe');
        if(iframe.length) {
            var subWindioDomain = iframe[0].src.substring(0, iframe[0].src.indexOf('/', 8));
            let intervalHandler;
            window.addEventListener('message', (event) => {
                console.log("recieved event from child", event)
                if(subWindioDomain === event.origin && event.data.type === 'ELKTokenFromDO' && event.data.isReceived === true){
                    console.log("now clear");
                    setQuestLoading(false);
                    window.clearInterval(intervalHandler);
                }
            });
            let info = getToken(access_token,refresh_token);
            console.log("sending tokens", info)
            let type = info.type;
            let token = info.token;
            intervalHandler = setInterval(() => {
                try {
                    iframe[0].contentWindow.postMessage({ type, token }, subWindioDomain);
                    // a[0].contentWindow.postMessage({ type, token },'http://localhost:3001/');
                } catch (error) {
                    console.log("error in post", error)
                }
            }, 200);
        }
    }
    const setWorkspaceOnFirstLogin = (workspaceSelected) => {
        setWorkspaceNotAvailable(false);
        setFirstTimeLogin(false);
        updateWorkspace(workspaceSelected);
        setWorkspace(workspaceSelected);
        WORKSPACES.map(workspace => (
            workspace.isSelected = (workspace.id === workspaceSelected ? true : false)
        ));
        setWorkspaceLoaded(true);
        let urlElements = window.location.href;
        if (!urlElements.includes("manage_operations")) {
            window.location.href = "/manage_operations";
        }
    }

    return (
        <div>
            <div className="App">
                <HeaderComponent workspace={workspace} workspaces={WORKSPACES} updateWorkspace={updateWorkspace} getEmailHandler={getEmailHandler} />
                <Suspense fallback={<div>{loadingLabel}</div>}>
                    {/* <section>
                        {showSessionTimeOut ? <ModalComponent kind="tertiary" children="Your session is about to expire. Please refresh" modalFooter={modalFooterSession()} onClickSecondary={handleClickCancel} onClick={handleClickLogin} /> : ''}
                    </section> */}
                    <section>
                        {showLoginTimeOut ? <ModalComponent kind="tertiary" children={SessionExpired} modalFooter={modalFooterLoginSession()} onClick={handleClickLogin} /> : ''}
                    </section>
                </Suspense>
                {/* added condition to hide quest icon in production */}
                {Cookies.get('session_token') && (configConst.URL.includes(configConst.staging) || configConst.URL.includes(configConst.development) || configConst.URL.includes(configConst.local)) ?
                    <Button className="do-notification" iconDescription={AskMe} renderIcon={QuestChat} onClick={toggleQuestModal}>
                        <span className='text'>{AskMe}</span>
                    </Button>
                    :
                    ''
                }
                {showQuestModal &&
                    <QuestModal showQuestModal={showQuestModal} questLoading={questLoading} toggleQuestModal={toggleQuestModal} onQuestLoad={onQuestLoad} />
                }
                {/* <iframe
                    src="http://localhost:3001/"
                    width="100%"
                    height="700"
                    onLoad={test}
                    frameBorder="0"
                    marginHeight="0"
                    marginWidth="0"
                /> */}
                {/* { sessionToken ?
                <div>
                {isFirstTimeLogin && isWorkspaceNotAvailable?
                    <div className="workspace-na">
                    <div className="carbon-display-Light-24">{SelectWorkspace}</div>
                    <div className="workspace-icons">
                        <div>
                        <img src={Automation} alt="" onClick={() => { setWorkspaceOnFirstLogin(WORKSPACES[0].id) }}/>
                        <div className="workspace-text carbon-display-Regular-24">{AutomationLabel}</div>
                        </div>
                        <div className="sap-tile">
                        <img src={SAP} alt="" onClick={() => { setWorkspaceOnFirstLogin(WORKSPACES[1].id) }}/>
                        <div className="workspace-text carbon-display-Regular-24">{SAPLabel}</div>
                        </div>
                    </div>
                    <div className="workspace-desc carbon-display-Regular-12">{UserPreferenceslabel1} {"\n"} {UserPreferenceslabel2}</div>
                    </div> : null}
                    </div> : null} 
                */}
            </div>
            <Router workspace={workspace} />
        </div>
    );
}
export default App;
